<template>
  <div class="sideNavbar">
    <CSCareshipLogo class="logo" />

    <div data-test="primary-nav-items">
      <NavigationItem
        v-for="(item, index) in navItems"
        :key="`item-${index}`"
        v-bind="item"
        @click="handleItemClick(item)"
        :active="handleActivePath(item, $route.path)"
        primaryItem
      />
    </div>

    <div data-test="bottom-nav-items" class="bottomLinks">
      <NavigationItem
        @click="handleItemClick(item)"
        v-bind="item"
        v-for="(item, index) in navLinks"
        :key="`link-${index}`"
      />
    </div>
  </div>
</template>

<script>
import CSCareshipLogo from '@/components/atoms/logo/CSCareshipLogo.vue'
import NavigationItem from '@/components/molecules/dashboard/navigation/navigationItem.vue'

export default {
  name: 'SideNavbar',

  components: {
    NavigationItem,
    CSCareshipLogo,
  },

  data() {
    return {
      navItems: [
        {
          icon: 'cs_users',
          text: this.translate('SIDENAV_ITEM_CAREGIVERS'),
          path: '/meine-alltagshelfer',
          activePath: '/meine-alltagshelfer',
          'data-test': 'my-caregivers-nav-item',
        },
        {
          icon: 'cs_calendar',
          text: this.translate('SIDENAV_ITEM_BOOKINGS'),
          path: '/meine-buchungen',
          activePath: '/meine-buchungen',
          'data-test': 'my-bookings-nav-item',
        },
        {
          icon: 'cs_bank',
          text: this.translate('SIDENAV_ITEM_PAYMENT_METHOD'),
          path: '/zahlungsmethode',
          activePath: '/zahlungsmethode',
          'data-test': 'payment-method-nav-item',
        },
        {
          icon: 'cs_account',
          text: this.translate('SIDENAV_ITEM_MY_PROFILE'),
          path: '/meine-familie',
          activePaths: ['/profil', '/meine-familie'],
          'data-test': 'my-profile-nav-item',
        },
      ].filter(item => !item.hidden),

      navLinks: [
        {
          icon: 'external-link',
          text: this.translate('SIDENAV_ITEM_CONSULTANT'),
          path: '/senioren-ratgeber',
          isExternalPath: true,
          'data-test': 'senior-guide-nav-item',
        },
        {
          icon: 'log-out',
          text: this.translate('SIDENAV_ITEM_LOGOUT'),
          path: '/logout',
          'data-test': 'logout-nav-item',
        },
      ],
    }
  },

  methods: {
    trackItemClick({ label }) {
      this.$gtm.trackEvent({
        category: 'customer app sidenav',
        action: 'user clicked on nav item',
        label,
        interactive: true,
      })
    },

    handleItemClick({ path, isExternalPath }) {
      this.trackItemClick({ label: path })

      if (isExternalPath) {
        window.location.href = path
        return
      }

      if (this.$route.fullPath === path) {
        return
      }

      this.$router.push(path)
      this.$emit('navItemClick')
    },

    handleActivePath(item, currentPath) {
      return (
        currentPath.includes(item.activePath) ||
        (item.activePaths && item.activePaths.includes(currentPath))
      )
    },
  },
}
</script>
